import { render, staticRenderFns } from "./SectionCompareList.vue?vue&type=template&id=50d8bd0d&scoped=true&"
import script from "./SectionCompareList.vue?vue&type=script&lang=js&"
export * from "./SectionCompareList.vue?vue&type=script&lang=js&"
import style0 from "./SectionCompareList.vue?vue&type=style&index=0&id=50d8bd0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d8bd0d",
  null
  
)

export default component.exports